import { Paragraph } from '@entur/typography';
import * as React from 'react';
export default {
  Paragraph,
  React
};